import $ from 'jquery';
import _ from 'underscore';
import autosize from 'lib/autosize';
import ajax from 'util/ajax';
import * as autosave from 'util/autosave';
import { initAutosubmit } from 'util/autosubmit';
import { $window, $body, jqGetElemById, jqOffOn } from 'util/global';
import * as latex from 'util/latex';
import { Anchors, showConfirmationModal } from 'util/ui';
import * as urls from 'util/urls';
import { errorModalHandler } from 'app/error_modal';
import { initGenericControllers } from 'app/generic_controllers';

/** @module */
const comments = {};

// Alex (11/13/2017): trying to get some more info on BP-14387
comments.hitPreviewSolution = false;

function renderCommentForm($formPlaceholder) {
  let formTemplate = null;
  let sortParam = null;
  const defaultData = {
    version: 1,
    commentId: null,
    formIdParentId: null,
    parentId: null,
    topLevelDiscCommentForm: false,
    paramKey: null,
    commentText: '',
    isEditingThis: false,
    commentFormSuccess: false,
    errors: '',
    commentUserIsStaff: false,
    commentUserName: null,
  };

  if (!$formPlaceholder.length || !$formPlaceholder.hasClass('comment-form-placeholder')) {
    $formPlaceholder = $formPlaceholder.find('.comment-form-placeholder');
    if (!$formPlaceholder.length) {
      return;
    }
  }

  const $tmpl = jqGetElemById('comment-form-template');
  formTemplate = _.template($tmpl.text());

  const params = urls.getParamsObject();
  if (params.sort) {
    sortParam = params.sort;
  }

  var formData = $formPlaceholder.data();

  // add sort param to form url
  if (sortParam && formData.formUrl.indexOf('sort=' + sortParam) < 0) {
    formData.formUrl = urls.appendGetParam(formData.formUrl, 'sort', sortParam);
  }

  // create the form id
  formData.formId = 'discussion_comment_form_id_';
  if (formData.formIdParentId) {
    formData.formId += 'parent_id_' + formData.formIdParentId;
  } else if (formData.commentId) {
    formData.formId += 'comment_' + formData.commentId;
  } else if (formData.postId) {
    formData.formId += 'post_' + formData.postId;
  } else {
    formData.formId += 'unknown';
  }

  // create the autosave key
  if (formData.formIdParentId) {
    formData.autosaveKey = 'comment-for-' + formData.formIdParentId;
  } else if (formData.commentId) {
    formData.autosaveKey = 'comment-' + formData.commentId;
  } else {
    formData.autosaveKey = 'top-comment-for-' + formData.postId;
  }

  // check for form errors
  var errorsElement = $formPlaceholder.find('.errorlist').get(0);
  if (errorsElement) {
    formData.errors = errorsElement.outerHTML;
  }

  // render the form and add to the page
  formData = _.extend({}, defaultData, formData);
  var $form = $(formTemplate(formData));
  var $parent = $formPlaceholder.parent();
  $formPlaceholder.replaceWith($form);

  // attach events
  comments.init();
  initGenericControllers($parent);
  _.defer(function () {
    $parent.find('form').off('submit');
    initAutosubmit($parent);
  });

  if (errorsElement) {
    $form.find('textarea:visible').focus();
  }
}

// the following fuctions are shared between
// discussions and solution discussions
// --------------------------------------------------

comments.editEvents = function ($root) {
  const parentQuery = '.cmmnt, .discsol-post';
  const clickWithScope = 'click.commentediting';

  $root.find('.edit-link .action').on('click', function () {
    var $editLink = $(this),
      $dropdownMenu = $editLink.find('.dropdown-menu');
    // is the dropdown menu fully visible on the screen when being aligned to the right?
    var rightAligned =
      $dropdownMenu.outerWidth() < $editLink.offset().left + $editLink.outerWidth() + 10;
    $dropdownMenu.toggleClass('pull-right', rightAligned);
  });

  jqOffOn($root.find('.edit-comment-trigger'), clickWithScope, e => {
    e.preventDefault();
    const $comment = $(e.currentTarget).parents(parentQuery);
    renderCommentForm($comment);
    $comment.addClass('editing');
    $comment.find('.comment-form').removeClass('previewing');
    const $textarea = $comment.find('textarea:visible');
    $textarea.trigger('focus');
    autosize($textarea);
    // if in localstorage, set value for textarea + clone
    const $field = $comment.find('fieldset');
    autosave.setVal($field);
  });

  jqOffOn($root.find('.cancel-edit-trigger'), clickWithScope, e => {
    e.preventDefault();
    const $comment = $(e.currentTarget).parents(parentQuery);
    $comment.removeClass('editing focused replying');
  });

  jqOffOn($root.find('.delete-trigger'), clickWithScope, e => {
    e.preventDefault();
    const $comment = $(e.currentTarget).parents(parentQuery);
    $comment.addClass('deleting');
  });

  jqOffOn($root.find('.delete-cancel-trigger'), clickWithScope, e => {
    e.preventDefault();
    const $comment = $(e.currentTarget).parents(parentQuery);
    $comment.removeClass('deleting');
  });

  $root
    .find('.saved')
    .delay(5000)
    .fadeOut(200, function () {
      $(this).remove();
    });
};

comments.expander = function ($root) {
  $root.find('.discsol-post .desc, .discsol-post .cmmnt .text').each(function () {
    var $this = $(this);
    if ($this.innerWidth() !== $this[0].scrollWidth) {
      $this.addClass('scrollable');
    }
  });
};

/** @param {string} commentId */
function getTrinaryVote(commentId) {
  const $parent = jqGetElemById(`voting_div_for_comment_${commentId}`);
  const votedUp = $parent.find('.vote-up.voted').length > 0;
  const votedDown = $parent.find('.vote-down.voted').length > 0;
  if (votedUp) {
    return 'True';
  } else if (votedDown) {
    return 'False';
  }
  return 'None';
}

var update_vote = function ($vote, amount) {
  var voteCount = $vote.data('vote-count') + amount;
  $vote.toggleClass('voted', amount > 0);
  $vote.data('vote-count', voteCount);
  $vote.find('.count').html(voteCount);
  $vote.blur();
};

function votes($container = $body) {
  const $comments = $container.find('.cmmnt');

  jqOffOn($comments.find('.vote'), 'click.commentvote', e => {
    var $vote = $(e.currentTarget),
      $parent = $vote.parents('.voting'),
      $vote_up = $parent.find('.vote-up'),
      $vote_down = $parent.find('.vote-down'),
      action_url = $parent.data('action_url'),
      comment_id = $parent.data('comment_id'),
      orig_trinary_vote = getTrinaryVote(comment_id);

    var trinary_vote = $vote.hasClass('vote-up') ? 'True' : 'False';
    if (orig_trinary_vote == trinary_vote) {
      trinary_vote = 'None';
    }

    $.ajax({
      type: 'POST',
      url: action_url,
      data: { comment_id: comment_id, vote: trinary_vote },
    })
      .fail(errorModalHandler)
      .then(function (result) {
        // Checking getTrinaryVote again to see if they submitted twice:
        var existing_trinary_vote = getTrinaryVote(comment_id);
        if (existing_trinary_vote == result.vote) {
          return; // already up to date with server
        }
        if (result.vote == 'None') {
          if (existing_trinary_vote == 'True') {
            update_vote($vote_up, -1);
          } else {
            update_vote($vote_down, -1);
          }
        } else if (result.vote == 'True') {
          update_vote($vote_up, 1);
          if (existing_trinary_vote == 'False') {
            update_vote($vote_down, -1);
          }
        } else if (result.vote == 'False') {
          update_vote($vote_down, 1);
          if (existing_trinary_vote == 'True') {
            update_vote($vote_up, -1);
          }
        }
      });
  });
}

comments.events = function ($container = $body) {
  var $forms = $container
    .find('.comment-form')
    .not(
      '#new_post_form_id, #new_solution_form_id, #new_dispute_form_id, #new_wikifeedback_form_id',
    );

  $forms.each((i, form) => {
    const $form = $(form);
    $form.find('textarea:visible').each((i, textarea) => {
      const $textarea = $(textarea);

      // do this instead of just calling autosize()
      // so that it doesn't make the empty textarea too large
      const hasContentHandler = () => {
        autosize($textarea);
        $form.addClass('focused');
        setTimeout(() => {
          $textarea.trigger('autosize.resize');
        }, 100);
      };

      if ($textarea.val()) {
        hasContentHandler();
      } else {
        $textarea.one('input', () => {
          hasContentHandler();
        });
      }
    });
  });

  const $buttons = $forms.find('.comment-form-buttons');

  jqOffOn($buttons.find('.preview'), 'click.previewlink', e => {
    e.preventDefault();
    const $this = $(e.currentTarget);
    const $parentForm = $this.parents('form');
    $this.parents('.comment-form-buttons').addClass('dim');
    $window.trigger($.Event(`comment.preview.${$parentForm.prop('id')}`));
    ajax('discussions_comments').form($parentForm.get(0), { preview_comment: true });
  });

  jqOffOn($buttons.find('.edit'), 'click.editlink', e => {
    e.preventDefault();
    $(e.currentTarget).parents('.comment-form').removeClass('previewing');
    comments.events($container);
  });

  $buttons.find('[type=submit]').on('click', function () {
    $(this).parents('.comment-form-buttons').addClass('dim');
  });

  // expand/collapse threads
  $container.find('.cmmnt').each(function () {
    var $comment = $(this);
    var $nextCommentContainer = $comment.next('.cmmnt-container');
    var $replyForm = $nextCommentContainer.find('.reply-form-wrapper');
    var $showReplies = $comment.find('.show-replies');
    var $hideReplies = $comment.find('.hide-replies');
    var $replyLink = $comment.find('.reply-unhide-link');

    $showReplies.on('click', function () {
      $comment.addClass('expanded');
      $nextCommentContainer.removeClass('hide');
      if (!$replyForm.hasClass('replying')) {
        $replyLink.removeClass('hide');
      }
      if ($showReplies.data('show-all-replies') === true) {
        $comment.parents('.cmmnt-container').addClass('show-all-replies');
      }
    });

    $hideReplies.on('click', function () {
      $comment.removeClass('expanded');
      $nextCommentContainer.addClass('hide');
      $replyLink.addClass('hide');
    });
  });

  $container.find('.cmmnt:not(.solution)').each((i, elem) => {
    const $comment = $(elem);
    jqOffOn($comment.find('.reply-unhide-link'), 'click.unhidereply', e => {
      e.preventDefault();

      const $trigger = $(e.currentTarget);
      const commentId = $comment.data('comment');
      const $replyForm = $(`div.unhide_new_reply_${commentId}`);

      renderCommentForm($replyForm);

      $replyForm.toggleClass('replying');
      if ($replyForm.hasClass('replying')) {
        $trigger.addClass('hide');
        const $textarea = $replyForm.find('textarea');
        // if in localstorage, set value for textarea + clone
        const $field = $replyForm.find('fieldset');
        autosave.setVal($field);
        $textarea.trigger('focus');
        $replyForm.find('.cancel-edit-trigger').one('click', () => {
          $trigger.removeClass('hide');
        });

        // this also includes course feedback and content reports
        const isQandA = $trigger.closest('.qanda-comments').length > 0;
        if (isQandA) {
          // the reply form is part of the subsequent hidden container
          // so show the entire thread to make the form visible
          $trigger.closest('.comment-content').find('.show-replies').trigger('click');
        }
      }
    });
  });

  const $replyUnhideLinks = $container.find('.discsol-post').find('.reply-unhide-link');
  jqOffOn($replyUnhideLinks, 'click.comments', e => {
    const $link = $(e.currentTarget);
    const $formContainer = $link.parents('.discsol-post').next('.discsol-comments');
    $formContainer.toggleClass('hide-form');
  });

  // 'in reply to' preface for comments
  $container.find('.cmmnt .text').each(function () {
    var $text = $(this),
      data_key = 'preface-html',
      preface_html = $text.data(data_key);

    if (preface_html) {
      $('p:first', $text).prepend($(preface_html));
      $text.removeAttr('data-' + data_key).removeData(data_key);
    }
  });

  jqOffOn($forms.find('textarea'), 'focus.commentform', e => {
    // $forms is all of the forms on the page
    const $commentForm = $(e.currentTarget).parents('.comment-form');
    $commentForm.addClass('focused');
    autosize($commentForm.find('textarea:visible'));
  });

  votes();
  this.editEvents($container.find('.disc-comments'));

  $container
    .find('.top-level-comment-form,.cmmnt.editing,.reply-form-wrapper.replying')
    .each(function () {
      renderCommentForm($(this));
    });
};

/** @param {JQuery} [$container] */
comments.subscribe = ($container = $body) => {
  jqOffOn($container.find('a.discussions_subscribe'), 'click.dscsubscr', e => {
    e.preventDefault();
    const $link = $(e.currentTarget);
    const $form = $link.parents('form');
    const $checkbox = $form.find('input[type=checkbox]');
    const subscribed = !$link.hasClass('subscribed');
    const formData = $form.data();
    let $post = $form.parents('.disc-post');

    $link.parents('.wiggle').removeClass('wiggle');

    if ($post.length === 0) {
      $post = $('.disc-comments-list');
    }

    $checkbox.prop('checked', subscribed);
    $form.trigger('submit');

    if (!subscribed) {
      const $subscribedComments = $post.find('.comment-subscr[data-subscribed=true]');
      if ($subscribedComments.length > 0) {
        showConfirmationModal({
          title: formData.confirmModalTitle,
          text: formData.confirmModalText,
          cancelBtnText: formData.confirmModalCancel,
          confirmBtnText: formData.confirmModalOk,
        }).then(confirmed => {
          if (confirmed) {
            $subscribedComments.each((i, form) => {
              $(form).trigger('submit');
            });
          }
        });
      }
    }
  });
};

/**
 * Expands threads the target belongs to
 * @param {JQuery} $target
 */
comments.expandThreadsFor = function ($target) {
  $target.parents('.cmmnt-container').prev('.cmmnt').find('.show-replies').trigger('click');
};

/**
 * Expands/collapses formatting guide controlled by the link
 * @param {JQuery} $link
 */
comments.formattingGuideLink = function ($link) {
  var data, $guide;
  $link.on('click', function (e) {
    e.preventDefault();
    data = data || $link.data();
    $guide = $guide || $(data.target);
    $guide.fadeToggle(100, function () {
      if ($guide.is(':visible')) {
        Anchors.scrollToTarget($guide);
      }
    });
  });
};

// the following fuctions are only used in solution discussions
// but in this file to prevent circular dependencies
// with solution_discussions.js and solvables.js
// --------------------------------------------------

comments.init = function ($container = $body) {
  this.events($container);
  this.votes($container);
  this.subscribe($container);
  this.expander($container);

  // shrink large svgs
  latex.scaleSVG($container.find('.latexprocessor-block, .latexprocessor-inline'));
};

comments.votes = function ($container = $body) {
  var $upvote_buttons = $container.find('.discsol-vote').not('.inited').not('.disabled');

  $upvote_buttons.addClass('inited');
  $upvote_buttons.on('click', function () {
    var $btn = $(this),
      data = $btn.data(),
      // vote is actually trinary
      // True: vote up, False: vote down, None: no vote
      // vote up button is on/off -- so ignore False
      vote = data.currentVote === 'True' ? 'None' : 'True';

    // check if disabled
    if ($btn.hasClass('disabled')) {
      return;
    }
    $btn.addClass('disabled');

    // send vote
    $.ajax({
      type: 'POST',
      url: data.actionUrl,
      data: {
        post_id: data.postId,
        vote: vote,
      },
    })
      .fail(errorModalHandler)
      .then(function (response) {
        // un-disable button
        $btn.removeClass('disabled');
        if (response.success) {
          // update button status
          if (response.vote === 'True') {
            $btn.addClass('voted');
            data.count++;
          } else {
            $btn.removeClass('voted');
            data.count--;
          }
          $btn.data('current-vote', response.vote);
          var $count = $btn.find('.vote-count');
          if ($count.length) {
            $count.find('.count').html(data.count);
          } else {
            $btn.find('.count').html(data.count);
          }
        }
      });
  });
};

comments.add_form = () => {
  const $forms = jqGetElemById('new_post_form_id')
    .add('#new_solution_form_id')
    .add('#new_dispute_form_id')
    .add('#new_wikifeedback_form_id');
  const clickWithScope = 'click.dsc';

  $forms.each((i, elem) => {
    const $form = $(elem);
    const $buttons = $form.find('.comment-form-buttons');
    const $preview = $buttons.find('.preview');
    const $edit = $buttons.find('.edit');

    jqOffOn($preview, clickWithScope, e => {
      e.preventDefault();

      $buttons.addClass('dim');

      let data;
      if ($form.hasClass('edit-solution-form')) {
        data = { preview_comment: true };
        comments.hitPreviewSolution = true;
      } else {
        data = { preview_post: true };
      }

      $window.trigger($.Event(`discussion.preview.${$form.prop('id')}`));
      ajax('discussions').form(jqGetElemById($(e.currentTarget).data('preview_form_id')), data);
    });

    jqOffOn($edit, clickWithScope, e => {
      e.preventDefault();
      $form.removeClass('previewing');
    });
  });
};

module.exports = comments;
